import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Globe, Clock, Award } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex justify-center" data-id="element-15">
            <div className="relative rounded-full overflow-hidden w-72 h-72 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-white" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/kkPc3Y6XVbkwzruzuhueLP/IMG_2284.jpg" alt="Juliet González" className="w-full h-full object-cover object-center scale-125" data-id="element-17" />
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-18">
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-19">
              Sobre Juliet
            </h2>

            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-20">
              <p className="mb-4" data-id="element-21">
                Soy Juliet González,{' '}
                <strong data-id="element-22">psicóloga clínica graduada en Colombia</strong> con más
                de <strong data-id="element-23">5 años de experiencia</strong> en el acompañamiento
                terapéutico de niños y adultos. Actualmente trabajo en{' '}
                <strong data-id="element-24">Reading Behavioral Health</strong>, en el corazón de
                Berks County.
              </p>
              <p className="mb-4" data-id="element-25">
                Soy <strong data-id="element-26">bilingüe (español e inglés)</strong>, lo que me
                permite conectar profundamente con la comunidad latina y también
                atender a personas de habla inglesa. Entiendo los retos únicos
                que enfrenta nuestra comunidad — adaptarse a una nueva cultura,
                manejar el estrés diario, criar hijos entre dos mundos.
              </p>
              <p data-id="element-27">
                Mi formación en psicología clínica me brinda las herramientas
                para abordar una amplia gama de situaciones emocionales y
                conductuales, siempre desde un enfoque humano, respetuoso y
                basado en evidencia.
              </p>
            </div>

            <div className="bg-gray-50 border-l-4 border-teal-700 p-6 mb-8" data-id="element-28">
              <p className="text-gray-800 font-medium" data-id="element-29">
                Atención culturalmente sensible para la comunidad latina y
                bilingüe de Berks County.
              </p>
            </div>

            {/* Credentials Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-30">
              <div className="flex items-center p-3 rounded-lg bg-gray-50" data-id="element-31">
                <GraduationCap className="w-5 h-5 text-teal-700 mr-3" data-id="element-32" />
                <span className="text-sm font-medium text-gray-700" data-id="element-33">
                  Psicóloga Clínica
                </span>
              </div>
              <div className="flex items-center p-3 rounded-lg bg-gray-50" data-id="element-34">
                <Globe className="w-5 h-5 text-teal-700 mr-3" data-id="element-35" />
                <span className="text-sm font-medium text-gray-700" data-id="element-36">
                  Bilingüe
                </span>
              </div>
              <div className="flex items-center p-3 rounded-lg bg-gray-50" data-id="element-37">
                <Award className="w-5 h-5 text-teal-700 mr-3" data-id="element-38" />
                <span className="text-sm font-medium text-gray-700" data-id="element-39">
                  +5 años exp.
                </span>
              </div>
              <div className="flex items-center p-3 rounded-lg bg-gray-50" data-id="element-40">
                <Clock className="w-5 h-5 text-teal-700 mr-3" data-id="element-41" />
                <span className="text-sm font-medium text-gray-700" data-id="element-42">
                  Lun–Vie 8–4
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}